import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import translationGB from './i18n/en_GB/main.json'
import translationSE from './i18n/sv_SE/main.json'

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: translationGB },
      sv: { translation: translationSE }
    },
    fallbackLng: 'en',
    debug: false,
    keySeparator: true,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    },
    ns: ['translation'],
    defaultNS: 'translation',
    storedLang: localStorage.getItem('i18nextLng')
  })

export default i18next
